export const NOTIFICATIONS_PORTAL_CONTAINER_ID =
  "notifications-portal-container";
